// @ts-ignore
/* eslint-disable */
import { CommonResponse } from '@/types';
import { request } from 'src/utils/request';

export async function download(data?: { id?: string; version?: string }) {
  return request<CommonResponse<any>>('/api/v1/driver-libraries/download', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
}

export async function operate(data?: {
  id?: string;
  run_status: number; //1为启动，2为停止
}) {
  return request<CommonResponse<any>>('/api/v1/driver-service/operate', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
}

export async function deleteDrive(data: { id: string }) {
  return request<CommonResponse<any>>(`/api/v1/device-server/${data.id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export async function getLog(data: { id: string }) {
  return request<CommonResponse<any>>(`/api/v1/driver-service/log/${data.id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export async function getServices(data: {
  metric_time: string;
  metric_tags: string; //net_work_rx
  container_name?: string;
}) {
  return request<CommonResponse<{ series: { container_name: string; times: string[]; values: number[] }[] }>>(`/api/v1/monitor/services`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
}
